import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { makeStyles } from "@material-ui/core/styles";
import industryadaptbg from "../../../images/v4/salesReps/clientAdapt.png";
import ClientScrollBgDark from "../../../images/v4/whatsappAd/images/ClientScrollBgDark.png";

const useStyles = makeStyles(() => ({
  Client: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    padding: "85px 0 40px",
    "& .client-carousel": {
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right",
      "&.black": {
        backgroundImage: "none",
      },
      "@media only screen and (max-width: 768px)": {
        "& .logos-row": {
          height: "65px!important",
        },
      },
    },
    "& .header": {
      display: "flex",
      width: "33%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& .body": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& .header": {
        width: "40%",
      },
      "& .body": {
        marginTop: "40px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      padding: "20px 0",
      "& .header": {
        width: "60%",
      },
      "& .body": {
        marginTop: "30px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
        textAlign: "left",
      },
      "& .body": {
        flexDirection: "column",
        flexWrap: "wrap",
        rowGap: "15px",
      },
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
      padding: "16px 8px",
    },
  },
  clientDetails: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "30px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
    "& .header": {
      "@media only screen and (max-width: 768px)": {
        textAlign: "center",
        "& p": {
          width: "100%",
        },
      },
    },
  },
  clientContentContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media(max-width:768px)": {
      flexDirection: "column",
      justifyContent: "center",
      gap: "24px",
    },
  },
}));

const ClientCarousel = ({ title, logos, background, darkLayout, classname }) => {
  const classes = useStyles();

  // Distribute icons across three tracks
  const distributeIcons = (icons) => {
    const sortedIcons = [...icons].sort((a, b) => a.img.localeCompare(b.img));
    const track1 = [];
    const track2 = [];
    const track3 = [];

    sortedIcons.forEach((icon, index) => {
      if (index % 3 === 0) track1.push(icon);
      else if (index % 3 === 1) track2.push(icon);
      else track3.push(icon);
    });

    return { track1, track2, track3 };
  };

  const { track1, track2, track3 } = distributeIcons(logos);

  // Infinite Scroll logic
  useEffect(() => {
    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        const logos = this.track.querySelectorAll(".logo");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        this.row.style.height = logos[0].offsetHeight + 20 + "px";
        this.position =
          this.direction === "left" ? 0 : -this.track.offsetWidth / 3;
        this.animate();
      }

      animate() {
        const loop = () => {
          if (this.direction === "left") {
            this.position -= this.speed;
            if (this.position <= -this.track.offsetWidth / 3) this.position = 0;
          } else {
            this.position += this.speed;
            if (this.position >= 0) this.position = -this.track.offsetWidth / 3;
          }
          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(loop);
        };
        requestAnimationFrame(loop);
      }
    }

    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  return (
    <section
      className={classes.Client}
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="container">
        <div className={classes.clientContentContainer}>
          <div className="header">
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className={`font-wix-semibold font-20 ${darkLayout ? "font-white" : "color-black1"
                }`}
            >
              Clients
            </motion.p>
            <motion.h2
              className={`font-wix-semibold font-56 ${darkLayout ? "font-white" : "color-black1"
                }`}
              initial={{ opacity: 0, y: 50 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              {title}
            </motion.h2>
          </div>
          <div
            className={`client-carousel ${darkLayout ? classname ? 'dark' : "black" : "black"}`}
            style={{
              backgroundImage: `url(${darkLayout ? ClientScrollBgDark : industryadaptbg
                })`,
            }}
          >
            <div className="logos-container">
              <div className="scroll-container">
                {[
                  { data: track1, direction: "left", speed: 0.8 },
                  { data: track2, direction: "right", speed: 0.4 },
                  { data: track3, direction: "left", speed: 0.8 },
                ].map((track, idx) => (
                  <div
                    className="logos-row"
                    data-direction={track.direction}
                    data-speed={track.speed}
                    key={idx}
                  >
                    <div className="logos-track">
                      {track.data.map((logo, i) => (
                        <div className="logo font-18 font-wix-medium" key={i}>
                          <img alt={`logo-${i}`} src={logo.img} />
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientCarousel;
